var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.swiperList.length > 0)?_c('div',{staticClass:"header-banner"},[_c('div',{staticClass:"swiper-box"},[_c('pi-swipe',{attrs:{"list":_vm.swiperList}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }